import { useState } from "react";
import { array, option, nonEmptyArray } from "fp-ts";
import {
  Panel,
  Stack,
  Box,
  useIsMobileLayout,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../intl";
import { constNull, pipe, constTrue, flow } from "fp-ts/function";
import { useRemoteData } from "../../useRemoteData";
import * as remoteData from "../../RemoteData";
import { TermsAndConditionsProps } from "./TermsAndConditions";
import { DocumentListItem } from "./DocumentListItem";

export function TermsAndConditionsG4P(props: TermsAndConditionsProps) {
  const [isOpen, setOpen] = useState(props.open || false);
  const formatMessage = useFormatMessage();
  const isMobileLayout = useIsMobileLayout();
  const termsAndConditions = useRemoteData(props.getTermsAndConditions);
  const isOvd = props.variant === "OVD";
  const isTermDepositAccount = props.variant === "TermDeposit";

  const renderContent = () => {
    return pipe(
      termsAndConditions,
      remoteData.fold(
        constNull,
        constNull,
        flow(
          nonEmptyArray.filter(item =>
            pipe(
              item.contractualDocument,
              option.fold(constTrue, item => !item)
            )
          ),
          option.fold(constNull, documents => (
            <Stack column units={4}>
              {pipe(
                documents,
                array.map(document => <DocumentListItem document={document} />)
              )}
            </Stack>
          ))
        )
      )
    );
  };

  return (
    <Box column>
      <Panel
        status="active"
        isOpen={isOpen}
        enableAccordion={true}
        onSelect={option.some(() => setOpen(!isOpen))}
        headerIcon={option.none}
        title={formatMessage(
          isOvd
            ? "Overdraft.ReadDocuments.TermsAndConditions.title"
            : isTermDepositAccount
            ? "TermDepositAccount.ReadDocuments.TermsAndConditions.title"
            : "UKonto.ReadDocuments.TermsAndConditions.title"
        )}
        titleSize={"medium"}
        content={renderContent}
        stripSurroundingPadding={isMobileLayout}
      />
    </Box>
  );
}
